import localhttp from "../js/https-commons";

const CONTEXT_ACCESS = "/access";

const Plugin = {
  install(Vue) {
    let profilesPermissions = [];
    let user = {};

    Vue.prototype.$ = false;

    Vue.prototype.$getProfilesPermissions = function() {
      console.log(Vue.$keycloak.tokenParsed);
      const profileCode = Vue.$keycloak.tokenParsed.appProfile;
      console.debug("Search profile with: " + profileCode);
      return localhttp
        .get(CONTEXT_ACCESS + "/getAllByProfile/" + profileCode)
        .then(response => {
          profilesPermissions = response.data;
          this.$profileLoaded = true;
        })
        .catch(e => {
          this.$profileLoaded = false;
          console.log(e);
        });
    };

    Vue.prototype.$checkFunctionality = function(functionality) {
      console.debug(profilesPermissions);
      const find = profilesPermissions.find(
        element => element.functionality.tag === functionality
      );
      return find !== undefined;
    };

    Vue.prototype.$checkPermission = function(functionality) {
      const find = profilesPermissions.find(
        element => element.functionality.tag === functionality
      );

      return find !== undefined
        ? find.permission === "R"
          ? false
          : true
        : null;
    };

    Vue.prototype.$getUserAdmin = function() {
      const userCode = Vue.$keycloak.tokenParsed.preferred_username;
      console.debug("Search user with: " + userCode);
      return localhttp
        .get(CONTEXT_ACCESS + "/" + userCode)
        .then(response => {
          user = response.data;
        })
        .catch(e => {
          console.log(e);
        });
    };

    Vue.prototype.$userIsAdmin = function() {
      return user.admin === true ? true : false;
    };
  }
};

export default Plugin;
